import { observer } from "mobx-react-lite";
import { enhancedContentSourceLocation } from "../../../lib/ContentSource";
import { NetworkEvent } from "../../../lib/Events";
import { DbRecordedEvent } from "../../../State/EvidenceDB/DatabaseTypes";
import { IndentedBlock, SearchLocationLine, Literal, ContextLine, ContextSpan, EmphasizedResultSpan } from "../common-styles";
import { InteractiveRequestId } from "../CommonElements";
import { ContentSourceSearchResult } from "../../../lib/searchRecordedEvent";

const maxCharsPerLine = 108;


export const SearchResultDetailsView = observer(({
	event, searchResult, displayJson,
}: {
	displayJson?: (json: unknown) => void;
	event: DbRecordedEvent<NetworkEvent>;
	searchResult: ContentSourceSearchResult;
}) => {
	const { stringFound, position } = searchResult;
	let { prefix, suffix } = searchResult;
	let totalChars = prefix.length + stringFound.length + suffix.length;
	if (totalChars > maxCharsPerLine) {
		const charCountAvailableForPrefixAndSuffix = Math.max(0, maxCharsPerLine - stringFound.length);
		const suffixCharCount = Math.min(
			// Suffix char count can't have more characters than the suffix
			suffix.length,
			Math.max(
				// The number of characters left after the prefix is removed
				charCountAvailableForPrefixAndSuffix - prefix.length,
				// The equal(ish) share of available characters
				Math.floor(charCountAvailableForPrefixAndSuffix / 2)
			)
		);
		const prefixCharCount = Math.min(prefix.length, charCountAvailableForPrefixAndSuffix - suffixCharCount);
		suffix = suffix.slice(0, suffixCharCount);
		prefix = prefix.slice(prefix.length - prefixCharCount);
	}
	const enhancedLocation = enhancedContentSourceLocation(searchResult);
	return (
		<IndentedBlock>
			<SearchLocationLine>
				<Literal>{enhancedLocation}:{position}</Literal>
				&nbsp;in request&nbsp;
				<InteractiveRequestId displayJson={displayJson} event={{ ...event, searchResults: [searchResult] }} />
			</SearchLocationLine>
			{prefix.length === 0 && suffix.length === 0 ? null : (
				<ContextLine>
					<ContextSpan>{prefix}</ContextSpan>
					<EmphasizedResultSpan>{stringFound}</EmphasizedResultSpan>
					<ContextSpan>{suffix}</ContextSpan>
				</ContextLine>
			)}
		</IndentedBlock>
	);
});
